import { CicadaAddInError } from "../../errors";
import { DATA_SOURCE_WORKSHEET_NAME } from "../../globalValues";
import { resetTableColors } from "../../resetTableColors";
import {
  SECURITIES_TABLE_ALIAS_COL_IDX,
  SECURITIES_TABLE_HEADER,
  SECURITIES_TABLE_ISIN_COL_IDX,
  SECURITIES_TABLE_NAME,
  SECURITIES_TABLE_NAME_COL_IDX,
} from "./config";
import { CreateSecuritiesTableArgs, UpdateSecuritiesTableArgs } from "./types";

export const getSecuritiesTableData = async (context: Excel.RequestContext) => {
  const sheet = context.workbook.worksheets.getItem(DATA_SOURCE_WORKSHEET_NAME);
  const table = sheet.tables.getItemOrNullObject(SECURITIES_TABLE_NAME);
  await context.sync();

  if (table.isNullObject) {
    throw new CicadaAddInError("Securities Table Error", "No securities table found");
  }

  const range = table.getRange();
  range.load("values");
  await context.sync();

  return range.values;
};

const deleteSecuritiesTable = async (context: Excel.RequestContext) => {
  const sheet = context.workbook.worksheets.getItem(DATA_SOURCE_WORKSHEET_NAME);
  const table = sheet.tables.getItemOrNullObject(SECURITIES_TABLE_NAME);
  await context.sync();

  if (table.isNullObject) {
    return;
  }
  const range = table.getRange();
  range.delete(Excel.DeleteShiftDirection.up);
};

export const createSecuritiesTable = async ({ context, securities }: CreateSecuritiesTableArgs) => {
  const sheet = context.workbook.worksheets.getItem(DATA_SOURCE_WORKSHEET_NAME);
  const securitiesCopy = securities.map((security) => {
    return [
      security[SECURITIES_TABLE_ISIN_COL_IDX],
      security[SECURITIES_TABLE_NAME_COL_IDX],
      security[SECURITIES_TABLE_ALIAS_COL_IDX],
    ];
  });

  let table = sheet.tables.getItemOrNullObject(SECURITIES_TABLE_NAME);
  await context.sync();

  if (!table.isNullObject) {
    await updateSecuritiesTable({ context, securities });
    return;
  }

  table = sheet.tables.add("A1:C1", true /*hasHeaders*/);
  table.name = SECURITIES_TABLE_NAME;
  table.getHeaderRowRange().values = [SECURITIES_TABLE_HEADER];

  resetTableColors({ table });

  [SECURITIES_TABLE_ISIN_COL_IDX, SECURITIES_TABLE_NAME_COL_IDX, SECURITIES_TABLE_ALIAS_COL_IDX].forEach((idx) => {
    table.columns.getItemAt(idx).getRange().numberFormat = [["@"]];
    table.columns.getItemAt(idx).getRange().format.horizontalAlignment = Excel.HorizontalAlignment.left;
  });

  await context.sync();

  table.rows.add(undefined, securitiesCopy);

  table.getRange().format.autofitColumns();
  table.getRange().format.autofitRows();

  await context.sync();
};

export const updateSecuritiesTable = async ({ context, securities }: UpdateSecuritiesTableArgs) => {
  await deleteSecuritiesTable(context);
  await createSecuritiesTable({ context, securities });
  await context.sync();
};
